import {
  Stack,
  InputWrapper,
  Select,
  Group,
  Button,
  Text,
  MultiSelect,
  TextInput,
} from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react"

import {
  datadoCiVisibilityMetricOptions,
  DatadogCIVisibilityDatasourceFormData,
} from "@costory/types/endpoints/metricsDatasources"

import { DatadogConfigSelect } from "@costory/front/pages/Datasources/components/common/DatadogConfigSelect"
import { useDatadogInstallationsQuery } from "@costory/front/queries/metricsDatasources"

export const DatadogCIVisibilityConfiguration = ({
  form,
  handleClickBack,
  handleClickNext,
}: {
  form: UseFormReturnType<DatadogCIVisibilityDatasourceFormData>
  handleClickBack: () => void
  handleClickNext: () => void
}) => {
  const datadogInstallationsQuery = useDatadogInstallationsQuery()
  return (
    <Stack h="100%">
      <Stack flex={1}>
        <DatadogConfigSelect form={form} query={datadogInstallationsQuery} />
        <InputWrapper
          label={
            <Text fw="bold" span={true}>
              Query
            </Text>
          }
          required
        >
          <TextInput
            {...form.getInputProps("query")}
            placeholder="Enter your query (ci_level:pipeline)"
            autoComplete="on"
          />
        </InputWrapper>
        <Group>
          <InputWrapper
            label={
              <Text fw="bold" span={true}>
                Aggregation
              </Text>
            }
            required
          >
            <Select
              {...form.getInputProps("aggregation")}
              autoComplete="on"
              data={datadoCiVisibilityMetricOptions}
            />
          </InputWrapper>
          <InputWrapper
            label={
              <Text fw="bold" span={true}>
                Metric
              </Text>
            }
            required
          >
            <Select
              {...form.getInputProps("metric")}
              defaultValue={null}
              placeholder="*"
              data={[
                "@ci.execution_time",
                "@duration",
                "@ci.queue_time",
                "@ci.wait_time",
              ]}
            />
          </InputWrapper>

          <InputWrapper
            label={
              <Text fw="bold" span={true}>
                Group By
              </Text>
            }
            required
          >
            <MultiSelect
              {...form.getInputProps("groupBy")}
              data={[
                "@ci.pipeline_name",
                "@ci.provider.name",
                "@git.branch",
                "@git.repository_url",
              ]}
              placeholder={
                form.getInputProps("groupBy").value &&
                form.getInputProps("groupBy").value.length > 0
                  ? ""
                  : "(Everything)"
              }
              searchable
              maxValues={1}
            />
          </InputWrapper>
        </Group>
      </Stack>
      <Group justify="space-between">
        <Button
          onClick={handleClickBack}
          variant="outline"
          leftSection={<IconArrowLeft />}
        >
          Back
        </Button>
        <Button
          disabled={!form.isValid()}
          onClick={handleClickNext}
          rightSection={<IconArrowRight />}
        >
          Next
        </Button>
      </Group>
    </Stack>
  )
}
